import React from 'react';
import config from '../../../../config';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import * as Yup from 'yup';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import { Switch } from '@mui/material';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';
import { useTranslation } from 'react-i18next';

const ExternalDistributor = () => {
  const urls = {
    list: config.EXTERNAL_DISTRIBUTOR,
    create: config.EXTERNAL_DISTRIBUTOR,
    update: config.EXTERNAL_DISTRIBUTOR_WITH_ID,
    delete: config.EXTERNAL_DISTRIBUTOR_WITH_ID
  };
  const resource = 'PROMO_DISTRIBUTOR';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id'),
      name: 'externalDistributorId',
      type: 'number',
      filterEditor: NumberFilter
    },
    {
      header: t('name'),
      name: 'externalDistributorName',
      type: 'string',
      required: true,
      validationSchema: Yup.string().max(255).required('Name is required'),
      isEditable: true,
      defaultFlex: 1
    },
    {
      header: t('description'),
      type: 'string',
      validationSchema: Yup.string().max(255).required('Description is required'),
      required: true,
      isEditable: true,
      name: 'externalDistributorDescription'
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      isEditable: true,
      filterEditor: BoolFilter,
      render: ({ value }) => <Switch disabled checked={value} />
    },
    {
      header: t('date.added'),
      name: 'dateAdded',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('date.modified'),
      name: 'dateModified',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    }
  ];

  return (
    <>
      <Header title={t('external.distributors')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'externalDistributorId'}
        tableId={'externalDistributor'}
        columns={columns}
        urls={urls}
      />
      <NavBar />
    </>
  );
};

export default ExternalDistributor;
